<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
     <div>

       <keep-alive >
          <router-view v-if="$route.meta.keepAlive"></router-view>
       </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <div  class="SignFlowHomepage-footer">Copyright &copy; {{new Date().getFullYear()}} 毒物（奢）技术团队. All rights reserved.</div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
  created(){
    console.log(this.$route.meta);
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue